import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import Image from "../components/Image";
import MarkDown from "../components/MarkDown";
import usePageReset from "../hooks/usePageReset";
import useProgram from "../hooks/useProgram";
import structuredData from "../assets/structuredText";

export default function ProgramPage() {
  const { programID } = useParams();
  const programDetails = useProgram(programID ? programID : "/404");
  usePageReset();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keywords" content="cultiv program incubation incubator accelerator startup" />
        <meta name="description" content="A program implemented by Cultiv llc" />
        <meta name="robots" content="index, follow" />

        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="image_src" itemProp="image" href="https://cultiv.llc/images/metaimg.jpg" />
        <meta property="og:description" content="A program implemented by Cultiv llc" />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Cultiv | ProgramPage" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv | ProgramPage" />
        <meta property="twitter:description" content="A program implemented by Cultiv llc" />
        <meta property="twitter:image" content="https://cultiv.llc/images/metaimg.jpg" />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>Cultiv | {`${programDetails ? programDetails.title : "Program"}`}</title>
      </Helmet>
      <div className="w-full grid grid-cols-4 lg:grid-cols-12 lg:gap-8 gap-4  md:px-15 lg:px-20 xl:px-30 px-6 pt-6">
        <h1 className="lg:text-4xl text-xl font-expandedBold col-span-full lg:pb-8 pb-3 border-b-2 border-gray-400 text-center">
          {programDetails?.title}
        </h1>

        <Image
          src={programDetails?.program_cover}
          height={630}
          className="lg:col-start-3 col-span-full lg:col-span-8 w-full"
          alt={programDetails?.title}
        />

        {programDetails?.description && (
          <MarkDown
            articleBody={programDetails.description}
            prosePadding="lg:col-start-3 col-span-full lg:col-span-8"
          />
        )}
        {programDetails?.apply_link && (
          <div className="lg:col-start-3 col-span-full lg:col-span-8 place-self-center">
            <div className="md:text-xl text-center ease-in-out duration-300 text-base bg-black text-white md:font-bold font-semibold border-white md:w-60 w-32 py-2 pt-3 hover:bg-cultiv-yellow hover:text-black">
              <a href={programDetails.apply_link}>Apply now</a>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
